import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-transport-area-service',
    templateUrl: './transport-area-service.component.html',
    styleUrls: ['./transport-area-service.component.css'],
    standalone: false
})
export class TransportAreaServiceComponent implements OnInit {
	@Input('type') type:any = {};
	@Input('area') area:string[] = [];
	@Input('description') description = '';
	constructor() { }

	ngOnInit(): void {
	}

}
